import * as types from './type'

const initialState = {
  data: [],
  dataList: [],
  loading: false,
  createSuccess: false,
  editLoad: false,
  deleteLoad:false,
}

export const smscampReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SMSCAMP:
      return {
        ...state,
        ...{ loading: true, createSuccess: false },
      }

    case types.GET_SMSCAMP_SUCCESS:
      return {
        ...state,
        ...{
          dataList: action.payload,
          loading: false
        }
      }

    case types.GET_SMSCAMP_FAIL:
      {
        return {
          ...state,
          ...{ dataList: [], loading: false }
        }
      }

    case types.CREATE_SMSCAMP:
      return {
        ...state,
        ...{ loading: true }
      }

    case types.CREATE_SMSCAMP_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        createSuccess: true,
      }

    case types.CREATE_SMSCAMP_FAIL:
      return {
        ...state,
        loading: false,
        data: action.payload.response.data,
      }

    
    case types.RESET_MESSAGE_ERROR:
      return {
        ...state,
        loading: false,
        data: []
      }
      //edit
      case types.EDIT_SMSCAMP: 
      return {
          ...state,
          editLoad: true,

      }
      case types.EDIT_SMSCAMP_SUCCESS:
      return {
          ...state,
          editLoad: false,
      }
      //remove
      case types.DELETE_SMSCAMP: 
      return {
          ...state,
          deleteLoad: true,

      }
      case types.DELETE_SMSCAMP_SUCCESS:
      return {
          ...state,
          deleteLoad: false,
      }
    default:
      return state
  }
}